import styled, { css } from "styled-components/native";
import FontWeightType from "../../models/FontWeightType";

interface StyledTextProps {
	fontSize: number;
	disabled?: boolean | null;
	fontWeight?: FontWeightType;
	fontColor?: string;
	textCenter?: boolean;
}

const StyledText = styled.Text<StyledTextProps>`
	font-size: ${(props) => props?.fontSize}px;
	height: 100%;
	width: 100%;
	justify-content: center;
	align-items: center;

	${(props) =>
		props.textCenter &&
		css`
			text-align: center;
		`}

	${(props) => {
		if (props.disabled) {
			return css`
				color: RGBA(255, 255, 255, 0.5);
			`;
		}
		const color = props.fontColor ? props.fontColor : "#FFF";

		return css`
			color: ${color};
		`;
	}}

	${(props) => {
		switch (props.fontWeight) {
			case FontWeightType.Light:
				return css`
					font-weight: 300;
				`;
			case FontWeightType.Medium:
				return css`
					font-weight: 500;
				`;
			case FontWeightType.Bold:
				return css`
					font-weight: 700;
				`;
			default:
				return css`
					font-weight: 400;
				`;
		}
	}}
`;

export default StyledText;
